import { render, staticRenderFns } from "./RouteHost.vue?vue&type=template&id=234eb8c4&scoped=true"
import script from "./RouteHost.vue?vue&type=script&lang=js"
export * from "./RouteHost.vue?vue&type=script&lang=js"
import style0 from "./RouteHost.vue?vue&type=style&index=0&id=234eb8c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234eb8c4",
  null
  
)

export default component.exports